// 2026-10-13：问答向平台和分店启用的后台管理账号开放，独立于平台超级管理员权限。
const positiveId = (value: unknown): boolean => {
  if (typeof value !== 'number' && typeof value !== 'string') return false
  const text = String(value).trim(), number = Number(value)
  return /^\d+$/.test(text) && Number.isSafeInteger(number) && number > 0
}

export const canAskGptQuestions = (token: unknown, user: any): boolean =>
  typeof token === 'string' && !!token.trim() && !!user
  && positiveId(user.id) && positiveId(user.orgId) && positiveId(user.roleId)
  && Number(user.disable) !== 1
  && (!('roleStatus' in user) || ((typeof user.roleStatus === 'number' || typeof user.roleStatus === 'string')
    && Number(user.roleStatus) === 1))
